import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DrawerProvider } from './contexts/DrawerContext';
import { Header } from './components/layout/Header';
import { UrgencyBar } from './components/home/UrgencyBar';
import { Footer } from './components/layout/Footer';
import { MobileActionBar } from './components/layout/MobileActionBar';
import { QuoteDrawer } from './components/drawers/QuoteDrawer';
import { UploadDrawer } from './components/drawers/UploadDrawer';
import { SEO } from './components/SEO';
import { Home } from './pages/Home';
import { RouteStub } from './pages/RouteStub';
import { BuyingProperty } from './pages/BuyingProperty';
import { SellingProperty } from './pages/SellingProperty';
import { ContractReview } from './pages/ContractReview';
import { About } from './pages/About';
import { Team } from './pages/Team';
import { Contact } from './pages/Contact';
const STUB_ROUTES = ['/first-home-buyers', '/smsf-trust-property', '/commercial-property', '/property-transfers', '/subdivisions', '/solicitor-certificates', '/about', '/team', '/resources', '/faqs', '/contact', '/get-a-quote', '/upload-contract', '/privacy', '/terms', '/disclaimer', '/accessibility', '/sitemap'];
export function App() {
  return <DrawerProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <SEO data-id="element-2" />
        <div className="flex flex-col min-h-screen w-full bg-background font-sans text-ink" data-id="element-3">
          <UrgencyBar data-id="element-4" />
          <Header data-id="element-5" />

          <div className="flex-1" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
              <Route path="/buying-property" element={<BuyingProperty data-id="element-11" />} data-id="element-10" />
              <Route path="/selling-property" element={<SellingProperty data-id="element-13" />} data-id="element-12" />
              <Route path="/contract-review" element={<ContractReview data-id="element-15" />} data-id="element-14" />
              <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
              <Route path="/team" element={<Team data-id="element-19" />} data-id="element-18" />
              <Route path="/contact" element={<Contact data-id="element-21" />} data-id="element-20" />
              {STUB_ROUTES.map(path => <Route key={path} path={path} element={<RouteStub data-id="element-23" />} data-id="element-22" />)}
            </Routes>
          </div>

          <Footer data-id="element-24" />
          <MobileActionBar data-id="element-25" />

          {/* Global Drawers */}
          <QuoteDrawer data-id="element-26" />
          <UploadDrawer data-id="element-27" />
        </div>
      </BrowserRouter>
    </DrawerProvider>;
}